import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal, Grid, Button } from 'semantic-ui-react';
import { AppState } from 'services/types';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Global Components
import ErrorAlert from 'components/ErrorAlert';
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';

// Actions
import { updateQueryString } from 'services/router/actions';
import { requestUncompleteSprayEvent } from 'services/sprayEvents/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

import { SPRAY_EVENT_UNCOMPLETE_NAMESPACE } from 'services/sprayEvents/constants';

import { SprayEventUuid } from 'services/sprayEvents/types';

import { UNCOMPLETE_SPRAY_EVENT_MODAL } from '../../constants';

interface ConnectedProps {
    [UNCOMPLETE_SPRAY_EVENT_MODAL]: boolean;
    uuid: SprayEventUuid;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
    requestUncompleteSprayEvent: typeof requestUncompleteSprayEvent;
}

type Props = ConnectedProps & DispatchProps;

export class UncompleteSprayEventModal extends React.PureComponent<Props> {
    get open(): boolean {
        const { uncompleteSprayEventModal, uuid } = this.props;
        return !!uncompleteSprayEventModal && !!uuid;
    }

    handleClose = (): void => {
        this.props.updateQueryString({
            [UNCOMPLETE_SPRAY_EVENT_MODAL]: undefined
        });
    };

    handleUncompleteSprayEvent = (): void => {
        const { uuid } = this.props;

        this.props.requestUncompleteSprayEvent(uuid);
    };

    render(): React.ReactElement {
        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace={UNCOMPLETE_SPRAY_EVENT_MODAL}
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>Uncomplete Spray Event</Modal.Header>
                        <Modal.Content>
                            <p>
                                Are you sure you want to uncomplete this event?
                            </p>
                            <ErrorAlert
                                namespace={SPRAY_EVENT_UNCOMPLETE_NAMESPACE}
                            />
                            <Grid>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <Button
                                        type="button"
                                        onClick={this.handleClose}
                                        fluid
                                        basic
                                        primary
                                    >
                                        Cancel
                                    </Button>
                                </Grid.Column>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <SubmittingButton
                                        type="button"
                                        namespace={
                                            SPRAY_EVENT_UNCOMPLETE_NAMESPACE
                                        }
                                        negative
                                        fluid
                                        onClick={
                                            this.handleUncompleteSprayEvent
                                        }
                                    >
                                        Uncomplete
                                    </SubmittingButton>
                                </Grid.Column>
                            </Grid>
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    [UNCOMPLETE_SPRAY_EVENT_MODAL]: makeSelectQueryStringValue(
        UNCOMPLETE_SPRAY_EVENT_MODAL
    ),
    uuid: makeSelectQueryStringValue('sprayEventUuid')
});

export default connect(mapStateToProps, {
    updateQueryString,
    requestUncompleteSprayEvent
})(UncompleteSprayEventModal);
